import slugify from 'slugify';
import joypixels from 'emoji-toolkit';

export const clamp = (num: number, min: number, max: number) => Math.min(Math.max(num, min), max);

export const itemsPerPageExtrato = 10;

export function FormatNumber(value: any, ceil = true) {
  try {
    if (isNaN(value)) return 0;
    return Intl.NumberFormat('pt-BR').format(ceil ? Math.ceil(value) : value);
  } catch (e) {
    return isNaN(value) ? 0 : value;
  }
}

export function stringToSearchPlayers(text: string) {
  if (typeof text !== 'string') return '';

  try {
    return slugify(text, ' ')
      .replace(/[.·/_\-,:;]+/g, ' ')
      .replace(/[\s]+/g, ' ')
      .trim()
      .toUpperCase();
  } catch (e) {
    return text
      .replace(/[.·/_\-,:;]+/g, ' ')
      .replace(/[\s]+/g, ' ')
      .trim()
      .toUpperCase();
  }
}

export function normalizeFuncionarioId(value: unknown): string {
  return String(value ?? '')
    .trim()
    .replace(/^F0*/i, '');
}

export function getIndexByValue(array: any, value: string) {
  return array.findIndex((element: any) => element.value === value);
}

export function stripHtmlTags(str: string) {
  try {
    if (str === null || str === '') return '';
    else str = str.toString();
    return str.replace(/<[^>]*>/g, '');
  } catch (e) {
    return str;
  }
}

export function convertEmojis(str: string) {
  const styles = [`width: 1.25em`, `height: auto`, 'display: inline-block', 'position: relative', 'top: -1px'];

  if (typeof str === 'string' && str.length) {
    return (joypixels.toImage(str) as string)
      .split(`<img class="joypixels"`)
      .join(`<img class="joypixels" style="${styles.join(';')}"`);
  } else {
    return '';
  }
}

// Retorna a etapa atual da Realização
export function getTaskStep(task: any) {
  if (!task || typeof task.status !== 'string') return undefined;

  // Etapa 2
  if (
    (task.status === 'rejeitado' || task.status === 'aguardando' || task.status === 'ciente') &&
    (typeof task.stageNumber === 'undefined' || task.stageNumber === 0)
  ) {
    return 2;
  }

  // Se tiver Pit Stop
  if (typeof task.prosseguir_gst === 'string') {
    if (task.prosseguir_gst === 'next' || task.prosseguir_gst === 'stopped') {
      return 4.1;
    } else {
      return 5;
    }
  }

  // Etapa 3, 4 e 5
  if (typeof task.multiplicador === 'number') {
    if (typeof task.stageNumber === 'number') {
      if (task.stageNumber === 1) {
        return 3;
      } else if (task.stageNumber === 2) {
        return 4;
      } else if (task.stageNumber === 3) {
        return 5;
      }
    } else {
      // Etapa 3
      if (task.multiplicador === 1) {
        return 3;
      }

      // Etapa 3
      if (task.status === 'dobrado' && task.multiplicador === 2) {
        return 3;
      }

      // Etapa 4
      if (task.status === 'promovido' && task.multiplicador === 2) {
        return 4;
      }

      // Etapa 4
      if (task.status === 'dobrado' && task.multiplicador === 4) {
        return 4;
      }

      // Etapa 5
      if (task.status === 'promovido' && task.multiplicador === 4) {
        return 5;
      }

      // Etapa 5
      if (task.status === 'dobrado' && task.multiplicador === 8) {
        return 5;
      }

      // Etapa 5
      if (task.status === 'selo') {
        return 5;
      }
    }
  }

  return undefined;
}

export const getPerformanceCategory = (percentage: number): JSX.Element => {
  if (percentage === 25) {
    return (
      <p>
        <strong>25%: Atuação Pontual:</strong>: execução de tarefas simples ou assistenciais de menor complexidade ou participação
        ativa nas discussões e geração de ideias.
      </p>
    );
  } else if (percentage === 50) {
    return (
      <p>
        <strong>50%: Atuação Parcial:</strong>: envolvimento em tarefas importantes, que impactam diretamente nos resultados da
        realização.
      </p>
    );
  } else if (percentage === 75) {
    return (
      <p>
        <strong>75%: Atuação Substancial:</strong>: protagonismo em aspectos específicos da realização ou resolução de desafios
        complexos.
      </p>
    );
  } else if (percentage === 100) {
    return (
      <p>
        <strong>100%: Atuação Integral:</strong>: condução global da realização destaque ou na solução de problemas críticos com
        sucesso.
      </p>
    );
  } else {
    return <p>Porcentagem inválida.</p>;
  }
};

export function getMonthNameFromString(inputString: string) {
  const months = [
    'Janeiro',
    'Fevereiro',
    'Março',
    'Abril',
    'Maio',
    'Junho',
    'Julho',
    'Agosto',
    'Setembro',
    'Outubro',
    'Novembro',
    'Dezembro',
  ];

  for (const month of months) {
    const regex = new RegExp(month, 'i');
    const match = inputString.match(regex);
    if (match) {
      return match[0];
    }
  }

  return inputString.replace(/^Nível\s*\d+\s*-\s*/, '');
}

export interface CalendarEvent {
  title: string;
  type: string;
  stage: string;
  period: string;
  start: Date;
  end: Date;
}

function cleanTitle(raw: string): string {
  return raw.replace(/^Nível\s*\d+\s*-\s*/, '');
}

export function getFutureCalendar(periods: any[], now: any): CalendarEvent[] {
  const events: CalendarEvent[] = [];

  for (const p of periods) {
    const title = cleanTitle(p.title);

    if (p._id === '68af4da8458e527eaa788503') {
      continue;
    }

    if (p.type === 'month') {
      // Validação
      if (p.date_evaluation_step2_start && p.date_evaluation_step2_finish) {
        events.push({
          title: `Validação (Líderes imediatos) - ${title}`,
          type: 'evaluation',
          stage: 'Validação (Líderes imediatos)',
          period: title,
          start: new Date(p.date_evaluation_step2_start),
          end: new Date(p.date_evaluation_step2_finish),
        });
      }

      // Nível 1
      if (p.date_evaluation_step3_start && p.date_evaluation_step3_finish) {
        events.push({
          title: `Apreciação Nível 1 - ${title}`,
          type: 'evaluation',
          stage: 'Apreciação Nível 1',
          period: title,
          start: new Date(p.date_evaluation_step3_start),
          end: new Date(p.date_evaluation_step3_finish),
        });
      }

      // Mensal
      if (p.date_start && p.date_finish) {
        events.push({
          title: `Cadastramento - ${title}`,
          type: 'register',
          stage: 'Cadastramento',
          period: title,
          start: new Date(p.date_start),
          end: new Date(p.date_finish),
        });
      }
    }

    if (p.type === 'trimester') {
      // Nível 2
      if (p.date_evaluation_step4_start && p.date_evaluation_step4_finish) {
        events.push({
          title: `Apreciação Nível 2 - ${title}`,
          type: 'evaluation',
          stage: 'Apreciação Nível 2',
          period: title,
          start: new Date(p.date_evaluation_step4_start),
          end: new Date(p.date_evaluation_step4_finish),
        });
      }

      // PitStop
      if (p.date_evaluation_pitStop_start && p.date_evaluation_pitStop_finish) {
        events.push({
          title: `Prosseguir - ${title}`,
          type: 'evaluation',
          stage: 'Prosseguir',
          period: title,
          start: new Date(p.date_evaluation_pitStop_start),
          end: new Date(p.date_evaluation_pitStop_finish),
        });
      }
    }

    if (p.type === 'semester') {
      // Nível 3
      if (p.date_evaluation_step5_start && p.date_evaluation_step5_finish) {
        events.push({
          title: `Apreciação Nível 3 (Gerentes Gerais UE e Diretores) - ${title}`,
          type: 'evaluation',
          stage: 'Apreciação Nível 3 (Gerentes Gerais UE e Diretores)',
          period: title,
          start: new Date(p.date_evaluation_step5_start),
          end: new Date(p.date_evaluation_step5_finish),
        });
      }
    }
  }

  return events.filter(e => e.end.getTime() > now).sort((a, b) => a.start.getTime() - b.start.getTime());
}

export function getFutureCalendarEcoa(periods: any[], now: any): CalendarEvent[] {
  const events: CalendarEvent[] = [];

  for (const p of periods) {
    const title = cleanTitle(p.title);

    if (p._id === '68af4da8458e527eaa788503') {
      continue;
    }

    if (p.type === 'month') {
      // Validação
      if (p.evaluation_ecoa_days_step2_start && p.evaluation_ecoa_days_step2_finish) {
        events.push({
          title: `Ciente e Validação - ${title}`,
          type: 'evaluation',
          stage: 'Ciente e Validação',
          period: title,
          start: new Date(p.evaluation_ecoa_days_step2_start),
          end: new Date(p.evaluation_ecoa_days_step2_finish),
        });
      }

      // Mensal
      if (p.date_start && p.date_finish) {
        events.push({
          title: `Cadastramento - ${title}`,
          type: 'register',
          stage: 'Cadastramento',
          period: title,
          start: new Date(p.date_start),
          end: new Date(p.date_finish),
        });
      }
    }

    if (p.type === 'semester') {
      // Nível 3
      if (p.date_evaluation_step5_start && p.date_evaluation_step5_finish) {
        events.push({
          title: `Apreciação Bonificação - ${title}`,
          type: 'evaluation',
          stage: 'Apreciação Bonificação',
          period: title,
          start: new Date(p.date_evaluation_step5_start),
          end: new Date(p.date_evaluation_step5_finish),
        });
      }
    }
  }

  return events.filter(e => e.end.getTime() > now).sort((a, b) => a.start.getTime() - b.start.getTime());
}

export function isGrupoValido(grupo: string): boolean {
  if (typeof grupo !== 'string' || grupo.trim() === '') {
    return false;
  }

  const gruposInvalidos = [
    'A CLASSIFICAR',
    'SAC-CONTINUO - REDE',
    'SAC CONTINUO - REDE',
    'DISEC/NAO AVALIAVEL',
    'DIPES/NAO AVALIAVEIS',
    'CONSELHO DIRETOR E AUDITOR GERAL',
    'CONSELHO DIRETOR/GG UE/AUDITOR GERAL',
    'ALTA LIDERANCA',
    'LIDERANCA ESTRATEGICA',
  ];

  return !gruposInvalidos.includes(grupo);
}

export const isReadOnly = (): boolean => localStorage.getItem('readOnly') === 'true';
